<template>
  <div>
    <div class="title-block">座席種別</div>
    <div class="column">
      <div class="field">
        <div class="select-wrap">
          <select v-model="selectedSeatType">
            <option>選択してください</option>
            <template
              v-for="(seat, idx) in selectedTrainInfo.seat_types"
              :key="idx"
            >
              <option :value="seat">
                {{ seat.name }}
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
    <p v-if="props.isShowChangeSaloonCaution" class="text-block">
      ※サルーンと他の席との間の変更はできません
    </p>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectSeatType",
  props: {
    selectedTrainInfo: {
      type: Object,
      required: true,
    },
    selectedSeatType: {
      required: true,
    },
    isShowChangeSaloonCaution: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const selectedSeatType = useVModel(props, "selectedSeatType");
    if (
      !props.selectedTrainInfo.seat_types.find(
        (seat) => seat.name === selectedSeatType.value.name
      )
    ) {
      selectedSeatType.value = "選択してください";
    }

    return {
      props,
      selectedSeatType,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.text-block {
  margin: 10px 6px;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
  color: #ed2323;
}

.float-text {
  float: right;
  font-weight: normal;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}
.field {
  position: relative;
  margin: 0 0 0 0;
}
/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -4px;
}
</style>
